import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { ExpiringPointModel, ProfileExpirePoint } from '../model/ExpiringPointModel';
import { PointHistoryModel } from '../model/PointHistoryModel';

/**
 * @method apiGetPointHistory
 * @method apiExpirePoint
 */
export default {
    /**
     * @param {Object} params HistoryPointConfigModel - /core/Point/config/PointConfigModel.js
     */
    apiGetPointHistory: function (params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/log/points';
        // const url = 'http://localhost:3000' + '/log/points';

        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let pointList = [];
            for (let i of res.data) {
                let point = new PointHistoryModel()
                point.setDataFromApi(i);
                pointList.push(point)
            }
            return pointList;
        }));
    },
    apiExpirePoint: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/profile/me/points_profile';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            let profileExpirePoint = new ProfileExpirePoint();
            profileExpirePoint.setDataFromApi(res.data);
            return profileExpirePoint;
        }));
    },
    apiExpiringPoint: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + '/profile/me/expiring_points';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            let expPoint = new ExpiringPointModel();
            expPoint.setDataFromApi(res.data);
            return expPoint;
        }));
    },
}
